const formatToThousandNumber = (value, precision) => `${(value / 1000).toFixed(precision) * 1}K`;

const formatToMillionNumber = (value, precision) => `${(value / 1000000).toFixed(precision) * 1}M`;

const formatToBillionNumber = (value, precision) =>
  `${(value / 1000000000).toFixed(precision) * 1}B`;

// Helper function to format based on absolute value range
const formatByAbsoluteValue = (absValue, value, precision) => {
  if (absValue <= 999) {
    return value.toFixed(precision) * 1;
  }
  if (absValue <= 999999) {
    return formatToThousandNumber(value, precision);
  }
  if (absValue <= 999999999) {
    return formatToMillionNumber(value, precision);
  }
  if (absValue <= 999999999999) {
    return formatToBillionNumber(value, precision);
  }
  return value.toFixed(precision) * 1;
};

export const formatLongNumber = (value = 0, precision = 2) => {
  if (value === 0) {
    return '0';
  }

  const absValue = Math.abs(value);

  return formatByAbsoluteValue(absValue, value, precision);
};

export const formatInput = (input) => {
  if (input === undefined || input === null || input === 'NA' || input === 'N/A' || input === '') {
    return 'N/A';
  }
  const formattedValue = Number(input).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formattedValue;
};

export const formatNumberUsingUnit = (input, unit) => {
  const formatedInput = formatInput(input);

  if (formatedInput === 'N/A') {
    return 'N/A';
  }

  switch (unit) {
    case '$':
      return formatedInput.includes('-')
        ? `-${unit}${formatedInput.slice(1)}`
        : unit + formatedInput;
    case '%':
      return formatedInput + unit;
    case 'none':
      return formatedInput;
    default:
      return formatedInput;
  }
};

export const formatPercentValue = (val) =>
  typeof val === 'number' && !isNaN(val) ? `${val.toFixed(2)}%` : 'N/A';
